import React, { useEffect } from 'react'
import Spinner from '../../Spinner'
import AnimationDots from '../../AnimationDots'

import UserWishlistProductItem from '../UserWishlistProductItem'

import * as S from './styles'

interface IDataProductProps {
    items: {
        images: {
            imageUrl: string;
        }[]

        sellers: {
            sellerName: string;
            commertialOffer: {
                Price: number;
            };
        }[]
    }[];
    linkText: string;
    productName: string;
    productReference: string;
    productId: string;
}

interface IUserWishlistProductsItemsProps {
    products: IDataProductProps[];
    loading: boolean;
    loadingNewItens: boolean;
    isEmpty: boolean;
    maxProductsFetched: boolean;
    onClickRemoveButtonHandler: (linkText: string) => void;
    onFetchNextProductPage: ()=> void;
}

const UserWishlistProductsItems: React.FC<IUserWishlistProductsItemsProps> = ({
    products,
    onClickRemoveButtonHandler,
    loading,
    loadingNewItens,
    isEmpty,
    maxProductsFetched,
    onFetchNextProductPage,
}) => {

    useEffect(()=>{
        const interserctionObserver = new IntersectionObserver((entries)=>{
            if(entries.some((entry)=> entry.isIntersecting)){
                onFetchNextProductPage()
            }
        });

        const targetElement = document.getElementById('sentinel');

        if(targetElement){
            interserctionObserver.observe(targetElement)
        }

        return () => interserctionObserver.disconnect();
    })

    return (
        <S.Container>
            <S.Title> Itens </S.Title>
            <S.UserWishlistItems>
                {
                    loading ?
                        <Spinner />
                        :
                        products.map((product) => (
                            <UserWishlistProductItem key={product.productReference + Math.random()} onClickRemoveButtonHandler={onClickRemoveButtonHandler} {...product} />
                        ))
                }

                {
                    !loading && isEmpty && <S.IsEmptyMessage> Adicione algum item na sua lojinha!</S.IsEmptyMessage>
                }

                {
                    !maxProductsFetched && !loading && !isEmpty && (
                        loadingNewItens
                        ? <S.LoadingContainer> <AnimationDots/> </S.LoadingContainer>
                        : <S.Sentinel id="sentinel"/>
                    )
                }

                </S.UserWishlistItems>
        </S.Container>
    )
}



export default UserWishlistProductsItems